import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { CustomCapabilityConfigurationForm } from '../../../../../core/forms';
import { MatRadioModule } from '@angular/material/radio';
import { KeyValuePair } from '@vendasta/ai-assistants';

export const DEFAULT_SALES_COACH_GOAL_ID = 'DefaultSalesCoach';

type SalesMethodology = 'MEDDPICC' | 'BANT' | 'SANDLER';

const methodologyOptions: { name: string; value: SalesMethodology }[] = [
  {
    name: 'AI_ASSISTANT.SETTINGS.SALES_COACH.SALES_METHODOLOGY.MEDDPICC',
    value: 'MEDDPICC',
  },
  {
    name: 'AI_ASSISTANT.SETTINGS.SALES_COACH.SALES_METHODOLOGY.BANT',
    value: 'BANT',
  },
  {
    name: 'AI_ASSISTANT.SETTINGS.SALES_COACH.SALES_METHODOLOGY.SANDLER',
    value: 'SANDLER',
  },
];

@Component({
  selector: 'ai-sales-coach-capability-form',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatOptionModule,
    TranslateModule,
    GalaxyFormFieldModule,
    MatRadioModule,
  ],
  templateUrl: './sales-coach-capability-form.component.html',
})
export class SalesCoachCapabilityFormComponent extends CustomCapabilityConfigurationForm {
  protected readonly methodologyOptions = methodologyOptions;
  value = computed(
    () => (this.configurationForm().value || []).filter((pair) => pair.key === 'methodology')[0]?.value || 'MEDDPICC',
  );

  protected onSalesMethodologySelected(event: { value: string }) {
    this.configurationForm().setValue([new KeyValuePair({ key: 'methodology', value: event.value })]);
  }
}
